import React, { Component } from 'react';
import { Row, Col, FormGroup, Radio, Checkbox } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { getMemberNameByUserId } from '../../utils';

export default class LicensingPermissions extends Component {
  constructor(props) {
    super(props);
    this.state = { all: false };
  }

  options = () => ({
    field1: this.props.field1,
    licenserIds: this.props.licenserIds,
  });

  componentWillReceiveProps(nextProps) {
    const { licenserIds, workOwnerships } = nextProps;
    if (workOwnerships && licenserIds) {
      let all = true;
      workOwnerships.forEach((member) => {
        all = all && licenserIds.indexOf(member.user) !== -1;
      });
      this.setState({ all });
    }
  }

  handleContent(field, index) {
    const options = this.options();
    options[field] = index;

    let checked = false;
    if (field === 'field1' && index === 0) {
      checked = true;
      options.licenserIds = [];
    } else if (field === 'licenserIds') {
      if (index && index.length) {
        checked = true;
      }
    }

    this.props.updateBlock(
      this.props.block.id,
      { content: '', checked },
      options
    );
  }

  handleMember(e, id) {
    const { workOwnerships, licenserIds } = this.props;
    let ids = [];

    if (id === 'all') {
      if (e.target.checked) {
        ids = workOwnerships.map((member) => member.user);
      }
    } else {
      ids = licenserIds ? licenserIds.concat() : [];
      if (e.target.checked) {
        if (ids.indexOf(id) === -1) {
          ids.push(id);
        }
      } else {
        let index = ids.indexOf(id);
        if (index !== -1) {
          ids.splice(index, 1);
        }
      }
    }
    this.handleContent('licenserIds', ids);
  }

  getMemberChecked(id) {
    return this.props.licenserIds
      ? this.props.licenserIds.indexOf(id) !== -1
      : false;
  }

  render() {
    return (
      <div className="tab-content">
        <Row>
          <Col sm={12}>
            <p className="question">
              Which collaborators may enter into direct, non-exclusive licenses
              on behalf of the others?
            </p>
            <FormGroup className="answer">
              <Radio
                name="permissions"
                checked={this.props.field1 === 0}
                readOnly
                onClick={(e) => this.handleContent('field1', 0)}
              >
                None
              </Radio>
              <Radio
                name="permissions"
                checked={this.props.field1 === 1}
                readOnly
                onClick={(e) => this.handleContent('field1', 1)}
              >
                Select applicable collaborators
              </Radio>

              {this.props.field1 === 1 ? (
                <FormGroup className="answer">
                  <Checkbox
                    checked={this.state.all === true}
                    onChange={(e) => this.handleMember(e, 'all')}
                  >
                    Select All
                  </Checkbox>
                  {this.props.workOwnerships &&
                    this.props.workOwnerships.map((member, i) => (
                      <Checkbox
                        key={i}
                        checked={this.getMemberChecked(member.user)}
                        onChange={(e) => this.handleMember(e, member.user)}
                      >
                        {getMemberNameByUserId(member.user, this.props.members)}
                      </Checkbox>
                    ))}
                </FormGroup>
              ) : null}
            </FormGroup>
          </Col>

          <Col sm={12}>{this.props.children}</Col>

          <Col sm={12}>
            <div className="notes">
              <h4>
                <FontAwesome name="question-circle" />
                Need Some Help?
              </h4>
              <div className="expand" tabIndex="0">
                <p className="question">Why is this important?</p>
                <p className="small">
                  Taking the time now to state who has permission to license
                  your work(s) helps you to avoid serious legal and financial
                  issues caused by the sale/use of your work(s) without proper
                  permission (e.g. collaborators licensing your work(s) to
                  others or for fees that you would not normally approve of).
                </p>
              </div>
              <div className="expand" tabIndex="0">
                <p className="question">What is a "direct license"?</p>
                <p className="small">
                  A "direct license" is a license that is obtained directly by
                  the owners of a work instead of from a third party.
                </p>
              </div>
              <div className="expand" tabIndex="0">
                <p className="question">What does non-exclusive mean?</p>
                <p className="small">
                  "Non-exclusive" means that a specific action is not solely
                  restricted or reserved to a specific party. In a non-exclusive
                  arrangement, multiple parties can perform the same action,
                  such as sell or license a work.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/components/ContractBlock/LicensingPermissions.jsx